import React from 'react';
import CoreComponent from "../../../../Core/CoreComponent";
import settings from '../../Settings/Settings';
import AppbarComponent from '../Appbar/Appbar';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ErrorSnackbar from '../../../../CommonComponents/ErrorSnackbar/ErrorSnackbar';
import IconButton from '@mui/material/IconButton';
import SearchCompatibleProducts from './Subcomponents/SearchCompatibleProducts'
import LoadingComponent from '../LoadingComponent/LoadingComponent'
import Pagination from '../../../../CommonComponents/Pagination/PaginationComponent';
import DeleteCompatibleProductDialog from './Subcomponents/DeleteCompatibleProductDialog';
import DeleteCompatibleProductProductDialog from './Subcomponents/DeleteCompatibleProductProductDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCompatibleProduct from './Subcomponents/AddCompatibleProduct';
import AddCompatibleProductProduct from './Subcomponents/AddCompatibleProductProduct'
import AddImage from './Subcomponents/AddImage';


export default class CompatibleProductsComponent extends CoreComponent {

    constructor(props) {
        super(props);
        this.loadComponentsProps()
        this.basicComponentConstants = {
            language: props.getManagerState().language,
            history: props.history
        }
    }

    componentDidMount() {
        this.getCompatibleProducts()

        super.componentDidMount()
    }
    loadComponentsProps() {
        const that = this
        this.setComponentsConstants('AppbarComponent', {
            ...this.basicComponentConstants
        }).setComponentsMethods('AppbarComponent', {
            setManagerState: (object, callback) => {
                that.props.setManagerState(object, callback)
            },
            addError: (errorMessage, stateObject) => {
               that.addErrorMain(errorMessage, stateObject)
           },
            refreshMainComponent: () => {
                that.refresh()
            },
            getManagerState: () => {
                return that.props.getManagerState()
            },
            changeRoute: (route) => {
                that.props.changeRoute(route)
            },
            getLocalStorage: (storageName) => {
                return that.getLocalStorage(storageName)
            },
            saveLocalStorage: (storageObject, storageName) => {
               that.saveLocalStorage(storageObject, storageName)
            },
            ajax: (url, 
                dataObject = {}, 
                method, stateValue = '', 
                callback = () => {}, 
                headers = {}, 
                setState = true, 
                catchCallback = () => {}) => {
                    that.ajax (url, 
                        dataObject, 
                        method, stateValue, 
                        callback, 
                        headers, 
                        setState, 
                        catchCallback);
                },
            getCompatibleProducts: () => {
                that.getCompatibleProducts()
            },
            deleteCompatibleProducts: () => {
                that.deleteCompatibleProducts()
            },
            deleteCompatibleProductsProduct: () => {
                that.deleteCompatibleProductsProduct()
            },
            setOpenDeleteCompatibleProducts: (value, compatibleProductsID) => {
                that.setOpenDeleteCompatibleProducts(value, compatibleProductsID)
            },
            setOpenDeleteCompatibleProductsProduct: (value, compatibleProductsProductID) => {
                that.setOpenDeleteCompatibleProductsProduct(value, compatibleProductsProductID)
            }
        })
    }
    getCompatibleProducts() {
        const that = this;
        let endpoint = settings.API_ENDPOINT_COMPATIBLE_PRODUCTS + '?accountToken=' + that.getLocalStorage('user').tokensHash
        if(this.props.urlParams && this.props.urlParams.query) {
            endpoint += '&q=' + this.props.urlParams.query
        }
        if(this.props.urlParams && parseInt(this.props.urlParams.page) > 1) {
            endpoint += '&page=' + this.props.urlParams.page
        }
        that.props.setManagerState({compatibleProducts: [], loadingCompatibleProducts: true}, () => {
            if(that.getLocalStorage('user')) {
                that.getSearchCompatibleProducts(endpoint)
            }    
        })
    }

    getSearchCompatibleProducts(endpoint) {
        this.props.setManagerState({orders: [], currentPagination: null, loadingOrders: true}, () => {
            this.ajax(settings.API_URL + endpoint,{},"GET", null, (data) => {
                this.props.setManagerState({compatibleProducts: data.items,currentPagination: data.pagination, loadingCompatibleProducts: false})
            })
        })
    }

    deleteCompatibleProducts() {
        const that = this;
        let endpoint = settings.API_ENDPOINT_COMPATIBLE_PRODUCTS + '/' + this.props.getManagerState().deleteCompatibleProductsID + '?accountToken=' + that.getLocalStorage('user').tokensHash
        that.props.setManagerState({compatibleProducts: [], loadingCompatibleProducts: true}, () => {
            if(that.getLocalStorage('user')) {
                this.ajax(settings.API_URL + endpoint,{},"DELETE", null, (data) => {
                    that.getCompatibleProducts()
                })
            }    
        })
    }

    deleteCompatibleProductsProduct() {
        const that = this;
        let endpoint = settings.API_ENDPOINT_COMPATIBLE_PRODUCTS_PRODUCT + '/' + this.props.getManagerState().deleteCompatibleProductsProductID + '?accountToken=' + that.getLocalStorage('user').tokensHash
        that.props.setManagerState({compatibleProducts: [], loadingCompatibleProducts: true}, () => {
            if(that.getLocalStorage('user')) {
                this.ajax(settings.API_URL + endpoint,{},"DELETE", null, (data) => {
                    that.getCompatibleProducts()
                })
            }    
        })
    }

    changePage(page) {
        let endpoint = settings.API_ENDPOINT_ORDERS + "?accountToken=" + this.props.getManagerState().user.tokensHash
        if(this.props.search === true) {
            endpoint = settings.API_ENDPOINT_ORDERS + '?q=' + this.props.urlParams.query  + "&accountToken=" + this.props.getManagerState().user.tokensHash
        }
        endpoint += '&page=' + page
        this.getCompatibleProducts(endpoint)
    }

    setOpenDeleteCompatibleProducts(value, compatibleProductsID) {
        this.props.setManagerState({
            openDeleteProductsDialog: value,
            deleteCompatibleProductsID: compatibleProductsID
        })
    }

    setOpenDeleteCompatibleProductsProduct(value, compatibleProductsProductID) {
        this.props.setManagerState({
            openDeleteProductsProductDialog: value,
            deleteCompatibleProductsProductID: compatibleProductsProductID
        })
    }
    getRender() {

        let classes = {
            root: {
              display: 'block',
              margin: '80px auto',
              padding: 8,
              '& > *': {
                margin: 1,
                width: 16,
                height: 16,
              },
            },
          };
        this.loadComponentsProps()

        let paginationPattern = window.location.pathname.replace(/page\/[0-9]+[\/]{0,1}/i,'').split('compatible/products')
        paginationPattern[1] = '/page/{{page}}'+ paginationPattern[1]
        paginationPattern = paginationPattern.join('compatible/products')
        return <div style={classes.root} id="rootComponent">
                    <DeleteCompatibleProductDialog {...this.buildComponentProps('AppbarComponent')} openDeleteDialog={this.props.getManagerState().openDeleteProductsDialog} />
                    <DeleteCompatibleProductProductDialog {...this.buildComponentProps('AppbarComponent')} openDeleteDialog={this.props.getManagerState().openDeleteProductsProductDialog} />
                    <AppbarComponent {...this.buildComponentProps('AppbarComponent')} />
                    <AddCompatibleProduct {...this.buildComponentProps('AppbarComponent')} addCompatibleProduct={true} element={{}} />
                    <SearchCompatibleProducts {...this.buildComponentProps('AppbarComponent')} />
                    <TableContainer component={Paper}>
                        <Table style={classes.table} aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{this.props.getManagerState().language.LANG_COMPATIBLE_PRODUCT_ID}</TableCell>
                                    <TableCell>{this.props.getManagerState().language.LANG_COMPATIBLE_PRODUCT_NAME}</TableCell>
                                    <TableCell>{this.props.getManagerState().language.LANG_COMPATIBLE_PRODUCTS_MANUFACTURER}</TableCell>
                                    <TableCell>{this.props.getManagerState().language.LANG_COMPATIBLE_PRODUCTS_TYPE}</TableCell>
                                    <TableCell>{this.props.getManagerState().language.LANG_COMPATIBLE_PRODUCTS_CODE}</TableCell>
                                    <TableCell  style={{width:"75%"}}>{this.props.getManagerState().language.LANG_COMPATIBLE_PRODUCT_COMPATIBLE_PRODUCTS}</TableCell>
                                    <TableCell >{this.props.getManagerState().language.LANG_IMAGES}</TableCell>
                                    <TableCell >{this.props.getManagerState().language.LANG_ACTIONS}</TableCell>
                                    </TableRow>
                            </TableHead>
                        <TableBody>
                    {this.props.getManagerState().compatibleProducts.map((el, idx) => [
                        <TableRow key={idx}>
                            <TableCell padding="checkbox">
                                {el.shopCompatibleProductsID}
                            </TableCell>
                            <TableCell>
                            <AddCompatibleProduct {...this.buildComponentProps('AppbarComponent')} editCompatibleProduct={true} element={el} />
                            </TableCell>
                            <TableCell>
                                {el.shopCompatibleProductsManufacturer}
                            </TableCell>
                            <TableCell>
                                {el.shopCompatibleProductsType}
                            </TableCell>
                            <TableCell>
                                {el.shopCompatibleProductsCode}
                            </TableCell>
                            <TableCell style={{width:"75%"}}>
                                <AddCompatibleProductProduct shopCompatibleProductsID={el.shopCompatibleProductsID} {...this.buildComponentProps('AppbarComponent')} />
                            </TableCell>
                            <TableCell style={{width:"75%"}}>
                                <AddImage {...this.buildComponentProps('AppbarComponent')} shopCompatibleProductsID={el.shopCompatibleProductsID} />
                            </TableCell>
                            <TableCell>
                            <IconButton onClick={(e) => {this.setOpenDeleteCompatibleProducts(true, el.shopCompatibleProductsID)}}><DeleteIcon /></IconButton>
                            </TableCell>
                        </TableRow>
                    ])}
                    </TableBody>
                    </Table>
                    </TableContainer>
                    <Pagination  {...this.buildComponentProps('Pagination')} pattern={paginationPattern} pagination={this.props.getManagerState().currentPagination} />
                     {
                        this.props.getManagerState().loadingCompatibleProducts ?
                        <LoadingComponent />
                        :
                        null
                    }
                </div>
    }
}
